import { render, staticRenderFns } from "./ThreeBig.vue?vue&type=template&id=58301802&scoped=true"
import script from "./ThreeBig.vue?vue&type=script&lang=js"
export * from "./ThreeBig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58301802",
  null
  
)

export default component.exports